import { makeStyles, Theme } from "@material-ui/core/styles";
import { tokens } from "@cobee/cobee-ui";
import { lightGrey } from "../../../infrastructure/theme/customColors";

interface Props {
  isEmpty: boolean;
  onRowClick?: (e: any) => void;
}

const useStyles = makeStyles<Theme, Props>(() => ({
  container: {
    height: ({ isEmpty }) => (isEmpty ? "500px" : "300px"),
  },
  table: {
    "& .MuiTableCell-head": {
      color: tokens.palette.common.white,
      ...tokens.typography["Body-M-400"],
    },
    "& .ReactVirtualized__Table__headerRow": {
      backgroundColor: tokens.palette.secondary.main,
      textTransform: "none",
    },

    "& .ReactVirtualized__Table__row": {
      borderBottom: `1px solid ${lightGrey}`,
      cursor: ({ onRowClick }) =>
        onRowClick !== undefined ? "pointer" : "default",
    },
  },
  tableCell: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    flex: 1,
    fontSize: "13px",
  },
  lastTableCell: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    flex: 1,
    paddingRight: 0,
  },
}));

export default useStyles;
